var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.items ? [_vm._l(_vm.items, function (item) {
    return item.key != 'TAX' || parseInt(item.unit) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('div', {
      staticClass: "d-flex align-start text-body-2"
    }, [item.key == 'TAX' ? _c('div', [_vm._v(_vm._s(item.meta.description))]) : _c('div', [_vm._v(_vm._s(item.title || item.key))]), item.disclaimer ? _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "icon": "",
        "x-small": "",
        "color": "grey"
      },
      on: {
        "click": function ($event) {
          return _vm.$confirm({
            title: item.title,
            msg: item.disclaimer,
            buttons: ['Ok'],
            primary: 'Ok',
            persistent: false
          });
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiInformation)
      }
    })], 1) : _vm._e(), item.qty > 1 ? _c('div', {
      staticClass: "ml-2 grey--text",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v("× " + _vm._s(item.qty))]) : _vm._e(), _c('v-spacer'), _c('price', {
      staticClass: "ml-2 flex-grow-0",
      attrs: {
        "color": item.unit.startsWith('-') ? 'green' : 'black',
        "value": (parseInt(item.unit.replace('.', '')) * item.qty / 100).toFixed(2)
      }
    })], 1), item.subtitle ? _c('div', {
      staticClass: "ml-4 overline short grey--text pr-16",
      staticStyle: {
        "font-size": ".6rem !important",
        "line-height": ".8rem !important"
      }
    }, [item.subtitle == 'DESIGN' ? void 0 : item.subtitle == 'VIDEO' ? void 0 : item.subtitle == 'GIFTCARD' ? [_c('currency', {
      attrs: {
        "code": item.meta.cur
      }
    }), _vm._v(_vm._s(item.meta.amt + ' – ' + item.meta.name) + " ")] : item.subtitle == 'CODE' ? [_vm._v(_vm._s(item.meta.code))] : item.subtitle == 'PCT' ? [_vm._v(" " + _vm._s(item.meta.pct * 100 + '% × ' + item.meta.subtotal) + " ")] : item.subtitle == 'SUB' ? [_vm._v(" " + _vm._s(item.meta.code) + " • " + _vm._s(item.meta.cadence)), item.meta.code == 'MULTI-USER' ? _c('span', [_vm._v(" • up to " + _vm._s(item.meta.max) + " users")]) : _vm._e()] : item.subtitle == 'SUB_CREDIT' ? [_vm._v(" " + _vm._s(item.meta.days_total - item.meta.days_elapsed) + " / " + _vm._s(item.meta.days_total) + " days unused ")] : [_vm._v(_vm._s(item.meta))]], 2) : _vm._e()]) : _vm._e();
  }), _c('v-divider', {
    staticClass: "my-3"
  })] : _vm._e(), _c('div', {
    staticClass: "d-flex font-weight-bold"
  }, [_c('div', [_vm._v("Total")]), _c('v-spacer'), _c('price', {
    attrs: {
      "value": _vm.itemized.price
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }